// Module
var code = "<designer ng-model=\"package\" designer=\"designer\" ng-if=\"loaded\"></designer>\n";
// Exports
module.exports = code;